import Modal from 'common/Modal'
import ModalContainer from 'common/ModalContainer'
import styles from './index.module.scss'
import useThriveAuth from 'hooks/useThriveAuth'

type ResetBookingModalProps = {
  show: boolean
  onSubmit: () => void
  onHide: () => void
}

const ResetBookingModal: React.FC<ResetBookingModalProps> = ({
  show,
  onSubmit,
  onHide,
}) => {
  const { isThirdPartyAgent } = useThriveAuth()

  return (
    <Modal
      show={show}
      backdrop="static"
      size="md"
      modalType="centered-content-height"
      contentClassOverride={styles.reset_modal_container}
      backdropClassName={styles.reset_booking_modal_backdrop}
    >
      <ModalContainer
        title="Start a new search"
        submitText="Start new booking"
        backText="Continue current booking"
        onSubmit={onSubmit}
        onClose={onHide}
        onCloseIcon={onHide}
        showBackIcon={false}
        showBottomBorder={false}
        submitClassName={styles.reset_booking_submit_btn}
        closeClassName={styles.reset_booking_cancel_btn}
        titleClassName={styles.reset_booking_modal_title}
      >
        <div className={styles.reset_modal_content}>
          This will reset all data related to this search
          {!isThirdPartyAgent &&
            ' (including any B2B/partner data), and start fresh for a new search'}
          .
        </div>
      </ModalContainer>
    </Modal>
  )
}

export default ResetBookingModal
